import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import {
  CITY_NOTES,
  DRIVER_NOTES,
  LOCALITY_NOTES,
  ALL_NOTES,
  SAMPLE_CSV_URL,
  TARGETABLE_TYPES,
  BANNER_DETAILS_ACTIONS,
} from "../constants";
import variables from "../../../constants/assets/variables";

import styled from "styled-components";
import BackThick from "sushiweb/Icons/all/BackThick";
import Chip from "@mui/material/Chip";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Box, Autocomplete, TextField } from "@mui/material";

import { setStatus, setLoader } from "../../../store/actions/User";

import DriverBanner from "../../../services/api/DriverBanner";

import InfoBar from "../common/InfoBar";
import BulkUploadFile from "../common/BulkUploadFile";
import InformationBar from "../../Common/InformationBar";

const TargetAudienceForm = (props) => {
  const { targetAudienceList, userAction, targetableBusiness, isApiLoading } =
    props;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const fixedOptions = [];
  const query = new URLSearchParams(location.search);
  const bannerId = query.get("id");
  const CSVMaxSize = 0.5;

  const [chipValues, setChipValues] = useState([]);
  const [file_path, setFilePath] = useState("");
  const [activeFile, setActiveFile] = useState("");
  const [presign_url, setPresignUrl] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [callback_key, setCallbackKey] = useState("");
  const [activeFileName, setActiveFileName] = useState("");
  const [sampleCsvDownloadUrl, setSampleCsvDownloadUrl] = useState("");
  const [bannerTargetData, setBannerTargetData] = useState([
    {
      banner_id: bannerId,
      assignment_type: "RECOMMENDED",
      scope: "driver",
      driver_service_ids: [],
    },
  ]);

  const handleChange = (valueList, idx) => {
    const ids = valueList.map((item) => item.id);
    setBannerTargetData((prevTargetAudience) => {
      const updatedTargetAudience = [...prevTargetAudience];
      updatedTargetAudience[idx] = {
        ...updatedTargetAudience[idx],
        driver_service_ids: ids,
      };
      return updatedTargetAudience;
    });
  };

  const handleClickBack = () => {
    // if(userAction === BANNER_DETAILS_ACTIONS.CREATE){
    //   const params = new URLSearchParams(location.search);
    //   params.set("action", BANNER_DETAILS_ACTIONS.VIEW);
    //   history.replace({ pathname: location.pathname, search: params.toString() });
    // } else {
    history.goBack();
    // }
  };

  const handleCreate = () => {
    const params = new URLSearchParams(location.search);
    params.set("action", BANNER_DETAILS_ACTIONS.CREATE);
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const resetFormState = () => {
    setChipValues([]);
    setFilePath("");
    setActiveFile("");
    setPresignUrl("");
    setIsDisabled(false);
    setCallbackKey("");
    setActiveFileName("");
    setBannerTargetData([
      {
        banner_id: bannerId,
        assignment_type: "RECOMMENDED",
        scope: "driver",
        driver_service_ids: [],
      },
    ]);
    setChipValues([]);
  };

  const handleCSVUpload = async () => {
    try {
      dispatch(setLoader(true));
      if (activeFile) {
        const res = await DriverBanner.getBulkUploadUrl({
          banner_id: bannerId,
          assignment_type: "RECOMMENDED",
          driver_service_ids: bannerTargetData[0].driver_service_ids,
          scope: bannerTargetData[0].scope,
        });
        dispatch(setLoader(false));

        if (res) {
          setCallbackKey(res.callback_key);
          setPresignUrl(res.file_upload_url);
          dispatch(
            setStatus({
              message: "Successfully Assigned",
              type: "success",
            })
          );
          resetFormState();
        } else {
          dispatch(
            setStatus({ type: "error", message: "Failed to upload file" })
          );
        }
      }
    } catch (err) {
      console.log(err);
      dispatch(setLoader(true));
      dispatch(
        setStatus({
          message: "Something went wrong",
          type: "error",
        })
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (bannerTargetData[0].scope !== "all") {
        handleCSVUpload();
      }
    else {
      bannerTargetData[0].entity_type = "Country"
      bannerTargetData[0].entity_values = ["1"]
      bannerTargetData[0].condition = [
        {
          "name": "service_id",
          "comparator": 4,
          "value": bannerTargetData[0].driver_service_ids
        }
      ]
    try {
      let response = await DriverBanner.createBannerTargetAudience(
        bannerTargetData[0]
      );
      if (response) {
        dispatch(
          setStatus({
            message: "Banner target audience added successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          setStatus({
            message: "Failed to add banner target audience",
            type: "error",
          })
        );
      }
      history.goBack();
    } catch (error) {
      dispatch(
        setStatus({
          message: "Something went wrong",
          type: "error",
        })
      );
    }
  }
  };

  const getTargetValues = (driver_service_ids) => {
    const targetValues = [];
    const x = driver_service_ids.forEach((value) => {
      const targetValue = targetableBusiness.find(
        (business) => business.id === value
      );
      if (targetValue) {
        targetValues.push(targetValue.name);
      }
    });

    return targetValues;
  };

  useEffect(() => {
    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${SAMPLE_CSV_URL}`
        : ""
    }`;

    if (SAMPLE_CSV_URL) {
      setSampleCsvDownloadUrl(download_url);
    }
  }, []);

  useEffect(() => {
    if (userAction === BANNER_DETAILS_ACTIONS.CREATE) {
      setIsDisabled(true);
    }
  }, [location]);

  useEffect(() => {
    const entitiesValuesLen = bannerTargetData[0].driver_service_ids.length;
    const isEntityTypeAll = bannerTargetData[0].scope === "all";
    const isBtnEnabled = activeFileName !== "" || isEntityTypeAll;

    if (isBtnEnabled && entitiesValuesLen > 0) {
      setIsDisabled(false);
    } else if (entitiesValuesLen === 0 || activeFileName === "") {
      setIsDisabled(true);
    }
  }, [activeFileName, bannerTargetData]);

  return (
    <>
      <BannerFormContainer>
        <BannerFormHeader>
          <BannerFormHeaderLeft>
            <BackButton color="#828282" onClick={handleClickBack} /> BANNER
            TARGET AUDIENCE
          </BannerFormHeaderLeft>
          <BannerFormHeaderRight>
            {userAction === BANNER_DETAILS_ACTIONS.VIEW ? (
              <ButtonFilled onClick={handleCreate}>Add new</ButtonFilled>
            ) : (
              <ButtonFilled
                type="submit"
                onClick={(e)=> {handleSubmit(e)}}
                disabled={isDisabled || isApiLoading}
              >
                Save
              </ButtonFilled>
            )}
          </BannerFormHeaderRight>
        </BannerFormHeader>
        {userAction === BANNER_DETAILS_ACTIONS.VIEW
          ? (targetAudienceList?.entity_mappings ?? []).map(
              (targAud, index) => {
                const targetableBusinessValues = getTargetValues(
                  targAud?.entity_value ?? []
                );
                return (
                  <BannerFormFieldCard key={index}>
                    <BannerFormField>
                      <BannerFormFieldLabel>
                        Targetable Type
                      </BannerFormFieldLabel>
                      <BannerFormFieldSelectInput
                        value={targAud?.entity_type}
                        name="entity_type"
                      >
                        {Object.keys(TARGETABLE_TYPES).map((targetType) => (
                          <option
                            key={targetType}
                            value={TARGETABLE_TYPES[targetType]?.code}
                          >
                            {TARGETABLE_TYPES[targetType]?.name}
                          </option>
                        ))}
                      </BannerFormFieldSelectInput>
                    </BannerFormField>
                    <BannerFormField>
                      <BannerFormFieldLabel>
                        Targetable Business
                      </BannerFormFieldLabel>
                      <Box
                        display="flex"
                        flexDirection="column"
                        overflow="auto"
                      >
                        <FormControl sx={{ width: 600 }}>
                          <Select
                            multiple
                            value={targetableBusinessValues}
                            renderValue={(selected) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip key={value} label={value} />
                                ))}
                              </Box>
                            )}
                          >
                            {(targetableBusiness ?? []).map((data) => (
                              <MenuItem key={data.name} value={data.name}>
                                {data.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </BannerFormField>
                  </BannerFormFieldCard>
                );
              }
            )
          : (bannerTargetData ?? []).map((targAud, index) => {
              return (
                <BannerFormFieldCard key={index}>
                  <BannerFormField>
                    <BannerFormFieldLabel>Targetable Type</BannerFormFieldLabel>
                    <BannerFormFieldSelectInput
                      value={targAud?.scope}
                      onChange={(e) => {
                        const value = e.target.value;
                        setBannerTargetData((prevTargetAudience) => {
                          const updatedTargetAudience = [...prevTargetAudience];
                          updatedTargetAudience[index] = {
                            ...updatedTargetAudience[index],
                            scope: value,
                          };
                          return updatedTargetAudience;
                        });
                      }}
                      name="scope"
                    >
                      {Object.keys(TARGETABLE_TYPES).map((targetType) => (
                        <option
                          key={targetType}
                          value={TARGETABLE_TYPES[targetType]?.code}
                        >
                          {TARGETABLE_TYPES[targetType]?.name}
                        </option>
                      ))}
                    </BannerFormFieldSelectInput>
                  </BannerFormField>

                  <BannerFormField>
                    <BannerFormFieldLabel>
                      Targetable Business
                    </BannerFormFieldLabel>
                    <Box {...assignmentContainerProps}>
                      <Autocomplete
                        multiple
                        value={chipValues}
                        onChange={(event, newValue) => {
                          handleChange(newValue, index);
                          setChipValues([...newValue]);
                        }}
                        sx={{
                          paddingRight: "0 !important",
                          marginBottom: "0 !important",
                        }}
                        options={targetableBusiness ?? []}
                        getOptionLabel={(option) => option.name}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index });
                            return (
                              <Chip
                                key={key}
                                label={option.name}
                                {...tagProps}
                                disabled={fixedOptions.includes(option)}
                              />
                            );
                          })
                        }
                        style={{
                          paddingRight: "0 !important",
                          marginBottom: "0 !important",
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="" placeholder="" />
                        )}
                      />
                    </Box>
                  </BannerFormField>

                  {bannerTargetData[0].scope !== "all" && (
                    <BannerFormField>
                      <BannerFormFieldLabel>Targetable</BannerFormFieldLabel>
                      <BulkUploadFile
                        instructions={""}
                        btnDataTestID="BulkUploadTargetBtn"
                        uploadUrl="/banner/bulk_assign/ack"
                        id="BulkUploadAssignModal"
                        maxSize={CSVMaxSize}
                        validateCSVSize={true}
                        sendExtraAck={true}
                        keyName="callback_key"
                        callback_key={callback_key}
                        presign_url={presign_url}
                        file_path={file_path}
                        activeFile={activeFile}
                        activeFileName={activeFileName}
                        setActiveFile={setActiveFile}
                        setActiveFileName={setActiveFileName}
                        setIsSaveBtnDisabled={setIsDisabled}
                      />
                    </BannerFormField>
                  )}
                  {bannerTargetData[0].scope !== "all" && (
                  <BannerFormField>
                    <BannerFormFieldLabel>
                      Download Sample CSV
                    </BannerFormFieldLabel>
                    <InformationBar
                      sampleUrl={sampleCsvDownloadUrl}
                      instructions=""
                      message=""
                    />
                  </BannerFormField>
                  )}
                  <BannerFormField>
                    <BannerFormFieldLabel>Note</BannerFormFieldLabel>
                    <InfoBar
                      instructions={
                        bannerTargetData[0].scope === "driver"
                          ? DRIVER_NOTES
                          : bannerTargetData[0].scope === "city"
                          ? CITY_NOTES
                          : bannerTargetData[0].scope === "locality"
                          ? LOCALITY_NOTES
                          : ALL_NOTES
                      }
                    />
                  </BannerFormField>
                </BannerFormFieldCard>
              );
            })}
      </BannerFormContainer>
    </>
  );
};

export const assignmentContainerProps = {
  sx: {
    width: "80%",
  },
};

const BannerFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const BannerFormHeader = styled.h1`
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #828282;
  gap: 12px;
`;

const BannerFormHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BannerFormHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ButtonFilled = styled.button`
  background-color: #ff5a5f;
  color: #fff;
  padding: 8px 32px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const BackButton = styled(BackThick)`
  cursor: pointer;
`;

const BannerFormField = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BannerFormFieldLabel = styled.label`
  font-size: 16px;
  width: 20%;
  font-weight: 500;
`;

const BannerFormFieldSelectInput = styled.select`
  padding: 8px;
  width: 80%;
  border: 1px solid #dddddd;
  border-radius: 8px;
  background-color: #fff;
  color: #000;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: #f5f5f5;
  }
  // target the arrow
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000' width='18px' height='18px'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px top 50%;
  background-size: 18px;
  padding-right: 24px;
`;

const BannerFormFieldCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 1px solid #dddddd;
  border-radius: 8px;
`;

export default TargetAudienceForm;
